import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  forgotPasswordToken: null,
};

const forgotPasswordSlice = createSlice({
  name: "forgot-password",
  initialState,
  reducers: {
    setForgotPasswordToken: (state, action) => {
      state.forgotPasswordToken = action.payload;
    },
    removeForgotPasswordToken: (state) => {
      state.forgotPasswordToken = null;
    },
  },
});

export const { setForgotPasswordToken, removeForgotPasswordToken } = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;
